import _ from 'lodash';
import translate from '../core/tools/translate';
import environment from '../environment';

import { CoreControl } from './CoreControl';
import { VectorType } from './VectorType';

export class BroadcastTVControl extends CoreControl {
    constructor () {
        super({ name: 'BroadcastTV' });

        this.select = this.select.bind(this);
    }

    static getInstance () {
        if (!BroadcastTVControl._instance) {
            BroadcastTVControl._instance = new BroadcastTVControl();
        }

        return BroadcastTVControl._instance;
    }

    init () {
        const values = {
            help: translate(`Help.${this.options.name}`),
            id: 'layer-tvstations',
            input: 'checkbox',
            label: translate(`Common.${this.options.name}`),
            layer: this.getLayer,
            change: this._change,
            name: this.options.name,
            type: 'vector-layers',
            scheme () {
                return Number(this.getControls().dropdown.station.value);
            }
        };

        const dataSource = _.map(environment.get('CONFIG.FILTERS.TV_STATIONS'), t =>
            ({ text: t.Nome, value: t.IdEmissora })
        );

        // Dealers with 1 brand don't need a dropdown
        if (_.size(dataSource)) {
            values.dropdown = [{
                name: 'station',
                dataSource,
                change: this.select
            }];
        }

        if (!this._instance) {
            this._instance = new VectorType(values);
        }
    }

    select (value) {
        this.getLayer().setOptions({
            remote: {
                params: {
                    id: value
                }
            }
        });
        if (this._instance.check()) {
            this.getLayer().redraw();
        }
    }
}

export default BroadcastTVControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/BroadcastTVControl.js